import React from "react";
import fadedStockyaariLogo from "../../assets/images/fadedStockyaariLogo.png"
import "./Footer.css"
const Footer = () => {
  return (
    <div className="footer-logo">
      {/* <StockYaariLogo /> */}
      <img src={fadedStockyaariLogo} alt="StockYaari Logo" />
      <p className="version-text">version 1.852</p>
    </div>
  );
};

export default Footer;
